import app from '../app';
import Component from '../../common/Component';
import humanTime from '../../common/helpers/humanTime';
import Icon from '../../common/components/Icon';
/**
 * Displays information about a the first or last post in a discussion.
 */
export default class TerminalPost extends Component {
  view() {
    const discussion = this.attrs.discussion;
    const lastPost = this.attrs.lastPost && discussion.replyCount();
    const user = discussion[lastPost ? 'lastPostedUser' : 'user']();
    const time = discussion[lastPost ? 'lastPostedAt' : 'createdAt']();
    return m("span", null, !!lastPost && m(Icon, {
      name: 'fas fa-reply'
    }), ' ', time && app.translator.trans('core.forum.discussion_list.' + (lastPost ? 'replied' : 'started') + '_text', {
      user,
      ago: humanTime(time)
    }));
  }
}
flarum.reg.add('core', 'forum/components/TerminalPost', TerminalPost);